<template>
   <Header></Header>
    <div class="lbt">
      <el-carousel  height="130vw">
        <el-carousel-item v-for="item in ban1.length" :key="item" >
            <el-image class="ban1_dt" :src="ban1[item-1].url"></el-image>
        </el-carousel-item>
      </el-carousel>
    </div>
  <!-- 分类 -->
  <div class="categorys clearfix">
    <div class="category" v-for="item of category" :key="item.category_sn" @click="toProd(item.category_sn,item.category_des)" >
      <el-image :src="item.icon_url"></el-image>
      <div class="category_des">{{ item.category_des }}</div>
    </div>
  </div>

  <!-- 新產品 -->
  <div class="cxcpdk clearfix">
    <div class="cxcp-title">新品推薦</div>
    <div class="cxcp-subtitle">堅持創新，完善產品</div>
    <div class="zp" v-for="item of cxcp" :key="item.index"   @click="openBox(item.prod_sn)">
      <el-image :src="item.url"></el-image>
      <div class="zpdes">{{ item.prod_des }}</div>
    </div>
  </div>

  <!-- 品牌介紹 -->
  <div class="ppjsmk">
    <div class="ppjs-title">品牌介紹</div>
    <div class="ppjs-subtitle">不忘初心，堅持創新</div>
    <div class="ppjs">
      <div><el-image class="ppjs-left" :src="ppjs"></el-image></div>
      <div class="ppjs-right">
        <div class="ppjs-right-title">IDEA</div>
        <div class="ppjs-right-subtitle">PHASE ——</div>
        <div class="ppjs-right-wz">
          <span class="ppjs-right-gs" >樂滿門床具有限公司</span>
          <span>
            經過30多年的發展，公司始終恪守
            "創新,品質，服務，經濟，奉獻感恩"的十二字理念。吸收新思想，嚴格控制品質，跟蹤全方位服務，堅持生產優質產品。</span
          >
        </div>
      </div>
    </div>
  </div>
  <Footer></Footer>
  <Box
  :dialogVisible="box.dialogVisible"
  :goods_id="box.goods_id"
  @close="boxClose"
></Box>
</template>

<script>
import Footer from "@/components/Footer_m";
import Header from "@/components/Header_m";
import Box from "@/components/Box_m";
export default {
  name: "home",
  data() {
    return {
      ban1: [{id: "00001", url: "https://nicedream.top:8202/gw_lmm/gw_lmm_prod/banner_phone2051116.jpg"}],
      category:[],
      xl: [
        "https://nicedream.top:8202/gw_lmm/home1.jpg",
        "https://nicedream.top:8202/gw_lmm/home2.jpg",
        "https://nicedream.top:8202/gw_lmm/home3.jpg",
      ],
      jt: "https://nicedream.top:8202/gw_lmm/home4.png",
      cxcp: [],
      //   品牌介紹
      ppjs: "https://nicedream.top:8202/gw_lmm/home5.png",
      box: {
        dialogVisible: false,
        goods_id: "",
      },
      place:"R", 
    };
  },
  created(){
    if(sessionStorage.getItem("company_sn")!=null){
      this.place=sessionStorage.getItem("company_sn")
        // this.queryBanner()
        this.queryProd()
        this.queryCategory()
    }
  },
  methods: {
    openBox(goods_id) {
      this.box.dialogVisible = true;
      this.box.goods_id = goods_id;
    },
    // 弹窗的搜索关闭
    boxClose(val) {
      this.box.dialogVisible = val;
    },
    // 查询广告
    queryBanner() {
      this.$api.banner({place:this.place}).then(
        res => {
          console.log(res)
          if (res.state == 10000) {
            this.ban1=res.data.banner
          } else {
            this.$message.error(res.msg);
          }
        },
        () => {
          this.$message.error("请求超时");
        }
      );
    },
    
    // 查询分类
    queryCategory() {
      this.$api.category({place:this.place}).then(
        res => {
          
          if (res.state == 10000) {
            console.log(res.data.category)
            this.category=res.data.category
          } else {
            this.$message.error(res.msg);
          }
        },
        () => {
          this.$message.error("请求超时");
        }
      );
    },
    // 查询推荐货品
    queryProd() {
      this.$api.queryprod({company_sn:this.place,category_sn:"",high:1}).then(
        res => {
          if (res.state == 10000) {
            this.cxcp=res.data.prod
          } else {
            this.$message.error(res.msg);
          }
        },
        () => {
          this.$message.error("请求超时");
        }
      );
    },
        // 跳转到编辑页面
    toProd(sn,des) {
      this.$router.push({
        path: "/goods/sf_m",
        name: "sf_m",
        query: { id: sn,des:des }
      });
    },
  
    toAbout() {
      this.$router.push({ path: "/about" });
    },
  },
  components: { Footer,Header,Box },
};
</script>

<style scoped>
.lbt {
  width: 100%;
  height: 130vw;
  margin-bottom: 10px;
}
.ban1_dt {
  width: 100%;
  height: 130vw;
}
.ban1_pt1 {
  width: 40vw;
  height: 40vw;
  position: relative;
  top: -45vw;
}
.ban1_wz1 {
  font-size: 30px;
  position: relative;
  top: -80vw;
  color: #fff;
}
.ban1_wz2 {
  position: relative;
  top: -77vw;
  font-size: 8px;
}
.ban1_wz3 {
  position: relative;
  top: -75vw;
  font-size: 8px;
  color: #fff;
}

/* 分类 */
.categorys{

  width: 92vw;
  margin: 0 auto;
}
.category{
  width: 23vw;
  height: 30vw;
  float: left;
}
.category .el-image{
  width: 22vw;
  height: 22vw;
}
.category_des{
  font-size: 13px;
}

/* 新品推薦 */
.cxcpdk {
  padding-top: 20px;
  padding-bottom: 15px;
}
.cxcp-title {
  font-size: 1.7rem;
  font-weight:700;
  color: #2b2b2b;
}
.cxcp-subtitle {
  font-size: 15px;
  line-height: 25px;
  color: #444444;
}
.zp {
  float: left;
  width: 44vw;
  height: 50vw;
  margin-left: 2.8vw;
  margin-top: 4vw;
  border-radius: 5px;
  box-shadow: 0 1px 8px 0 rgba(0, 0, 0, 0.1);
}
.zp .el-image {
  width: 44vw;
  height: 40vw;
}

/* 系列 */
.xl {
  height: 200px;
}
.xl-tp {
  height: 200px;
}
.xl-shang-left-wz {
  position: relative;
  top: -180px;
  text-align: left;
  margin-left: 30px;
}
.xl-shang-right-wz {
  position: relative;
  top: -180px;
  text-align: left;
  margin-left: 30px;
}
.xl-shang-title {
  font-size: 22px;
  color: #ffffff;
  margin-bottom: 15px;
}
.xl-shang-subtitle {
  line-height: 1.4;
  font-size: 12px;
  color: #ffffff;
}
.xl-shang-title2 {
  font-size: 22px;
  color: #3e3e3e;
  margin-bottom: 15px;
}
.xl-shang-subtitle2 {
  line-height: 1.4;
  font-size: 12px;
  color: #3e3e3e;
}
.xl-xia-wz {
  position: relative;
  top: -180px;
  text-align: left;
  margin-left: 30px;
}
.xl-xia-title {
  font-size: 22px;
  color: #ffffff;
  margin-bottom: 15px;
}
.xl-xia-subtitle {
  line-height: 1.4;
  font-size: 12px;
  color: #ffffff;
}
.xl-subtitle {
  height: 50px;
}
.mbtn {
  margin-top: 10px;
  text-align: right;
  margin-right: 30px;
}

/* 品牌介紹 */
.ppjsmk {
  width: 100%;
  height: 300px;
}
.ppjs-title {
  padding-top: 30px;
  font-size: 1.7rem;
  font-weight:700;
  color: #2b2b2b;
}
.ppjs-subtitle {
  line-height: 25px;
  color: #444444;
  margin-bottom: 20px;
  font-size: 15px;
}
.ppjs-left {
  height: 180px;
}
.ppjs-right {
  position: relative;
  width: 100%;
  text-align: left;
  top: -165px;
}
.ppjs-right-title {
  margin-left: 5vw;
  color: rgb(179, 141, 84);
  font-size: 22px;
  font-family: impact;
}
.ppjs-right-subtitle {
  margin-left: 5vw;
  color: #333;
  font-size: 22px;
  font-family: impact;
}
.ppjs-right-wz {
  margin-top: 15px;
  font-size: 12px;
  line-height: 24px;
  color: #333;
  margin-left: 10vw;
}
.ppjs-right-gs {
  color: rgb(179, 141, 84);
}
</style>